import React, { useEffect, useState } from 'react'
import ConfirmationPg from './ConfirmationPg';
import RenderTableCard from './RenderTableCard';
import TableWrapper from './tableComps/TableWrapper';

export default function TableCardsWrapper({ stims, pgStimCount, loading, data, addStims, paginationState, onPageChange, onRowsPerPageChange, setStims, card, setCard, togglePreview, displayPreview, handleAddAll, studyId, cellId, triggerStimsLoaded, triggerIframeReload, updateStep, setUpdateStep, searched, cachePgStep, setCachePgStep, styling }) {

    const stimCountArray = [...Array(pgStimCount).keys()];
    const [index, setIndex] = useState(0)
    const [updatedStimList, setUpdatedStimList] = useState([])

    function update(position) {
        setUpdateStep(true)
        // hit true
        setUpdatedStimList(updatedStimList.filter((selectedStim) => {
            return selectedStim.position !== position
        }))
    }

    function emptyUpdateStimArray() {
        setUpdatedStimList([])
    }

    // One pending change per slot, the same rule addStims enforces for stims. Without the
    // filter, choosing twice for the same slot queued two entries, and because the
    // completion gate counts stims.length + updatedStimList.length that made the page look
    // finished while a slot was still empty.
    function updatedStimArray(stim, position) {

        setUpdatedStimList((prev) => [
            ...prev.filter((entry) => entry.position !== position),
            { id: stim, position, update: true },
        ])
    }

    stimCountArray.forEach((stim, i) => {
        stimCountArray[i] = <TableWrapper
            stims={stims}
            pgStimCount={pgStimCount}
            loading={loading}
            data={data}
            addStims={addStims}
            paginationState={paginationState}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            card={card}
            setCard={setCard}
            stimPosition={String.fromCharCode(i + 97)}
            updateStep={updateStep}
            updatedStimList={updatedStimList}
            updatedStimArray={updatedStimArray}
            setUpdateStep={setUpdateStep}
            searched={searched}
        />
    })

    const letterStimPosition = String.fromCharCode(index + 97)

    function triggerRenderIndex(newPosition) {
        setIndex(newPosition)
    }

    function blankStimSlot() {
        if (updateStep) {
            // deduped by slot for the same reason as updatedStimArray - blanking one slot
            // twice used to queue it twice and inflate the completion count
            setUpdatedStimList((prev) => [
                ...prev.filter((entry) => entry.position !== letterStimPosition),
                { id: 0, position: letterStimPosition, remove: true },
            ]);

        } else {
            addStims(0, letterStimPosition)
        }
    }

    /*
     * The first slot with nothing assigned to it, by slot letter.
     *
     * This replaces `setIndex(stims.length)`, which assumed slots are always filled in
     * order, so "how many are filled" equalled "which slot is next". That holds on the first
     * pass but not after a removal: with slots b and c filled and a empty, the count is 2 and
     * pointed at slot c - a slot that already had a stim - instead of the empty slot a.
     */
    function firstEmptySlotIndex() {
        const taken = new Set([
            ...stims.map((stim) => stim.position),
            ...updatedStimList.map((entry) => entry.position),
        ])

        for (let slot = 0; slot < pgStimCount; slot++) {
            if (!taken.has(String.fromCharCode(slot + 97))) {
                return slot
            }
        }

        return 0
    }

    useEffect(() => {
        if (stims.length > 0) {
            setIndex(firstEmptySlotIndex())
        }
    }, [card])

    const filledSlots = stims.length + updatedStimList.length

    if (pgStimCount > filledSlots) {

        return <>
            <section>
                {/*
                  * Gated on the real filled count, not on `card`.
                  *
                  * `card` is a counter that addStims increments and nothing ever decrements,
                  * so once the page had been filled it stayed >= pgStimCount for good. After
                  * a removal this whole block - the slot heading AND the blank button -
                  * disappeared, leaving an empty panel with no way to reselect or blank the
                  * slot that had just been freed.
                  *
                  * Being inside the branch above already means a slot is free, so the same
                  * count is the right condition and the two can no longer disagree.
                  */}
                {pgStimCount > filledSlots
                    ? (<div style={{ display: "flex", width: "100%", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
                    >
                        <h2>select stim for slot {letterStimPosition}</h2>

                        <button onClick={blankStimSlot}>blank this stim slot</button>
                    </div>) : (<></>)}
                {/* {pgStimCount > stims.length ? (
                    <button
                        onClick={
                            () => {
                                setCard(card + 1)
                            }}
                    >
                        next Stim
                    </button>
                ) : (
                    <div>
                        you are no more stim slots available
                    </div>
                )}

                {card > 0 ? (
                    <button
                        onClick={() => {
                            setCard(card - 1)
                        }}
                    >
                        previous Stim
                    </button>
                ) : (
                    <div>
                        no previous stims available
                    </div>
                )} */}
            </section >


            <RenderTableCard
                render={stimCountArray} index={index} />
        </>

    } else {

        return <>

            {stims && stims.length > 0 ? (
                <>
                    {!displayPreview ? (
                        <ConfirmationPg
                            stims={stims}
                            pgStimCount={pgStimCount}
                            setStims={setStims}
                            setCard={setCard}
                            togglePreview={togglePreview}
                            handleAddAll={handleAddAll}
                            studyId={studyId}
                            cellId={cellId}
                            triggerStimsLoaded={triggerStimsLoaded}
                            triggerRenderIndex={triggerRenderIndex}
                            update={update}
                            updateStep={updateStep}
                            updatedStimList={updatedStimList}
                            cachePgStep={cachePgStep}
                            setCachePgStep={setCachePgStep}
                            triggerIframeReload={triggerIframeReload}
                            emptyUpdateStimArray={emptyUpdateStimArray}
                            styling={styling}
                        />
                    ) : (
                        null
                    )}
                </>
            ) : (
                <article>
                    <h3>there appears to have been a problem loading in your pg or stims</h3>

                </article>

            )}


        </>;
    }
}